module.exports = __webpack_public_path__ + "img/dollar_active.412571a2.svg";